import { Col, Container, Row } from "react-bootstrap";
import TurnoverForm from "../../../Components/Forms/TurnoverForm/TurnoverForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewTurnoverMutation } from "../../../services/bClientApi";

export default function AddTurnoverPage() {

    const [
        addNewTurnover,
        {
            isLoading,
            error
        }
    ] = useAddNewTurnoverMutation()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const newTurnover = await addNewTurnover(values).unwrap()
        if (newTurnover._id) {
            dispatch(navigateTo(`/turnover/${newTurnover._id}`))
        }
        return newTurnover
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Add Turnover</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <TurnoverForm
                        initialValues={{
                            type: '',
                            status: 'pending',
                        }}
                        disabled={isLoading}
                        onSubmit={handleSubmit}
                    />

                </Col>
            </Row>
        </Container>
    )
}
